<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright text-copyright">
        © {{ year }} {{ $t("layout.footer.copyrightBy") }}
        <a
          href="http://www.linkconsulting.com/"
          target="_blank"
          class="text-info"
          rel="noopener"
          >Link Consulting</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.text-copyright{
  font-family: "Montserrat";
}
</style>
